import { render, staticRenderFns } from "./sms-templates-x.vue?vue&type=template&id=18a9013f&scoped=true"
import script from "./sms-templates-x.vue?vue&type=script&lang=js"
export * from "./sms-templates-x.vue?vue&type=script&lang=js"
import style0 from "./sms-templates-x.vue?vue&type=style&index=0&id=18a9013f&prod&lang=scss&scoped=true"
import style1 from "./sms-templates-x.vue?vue&type=style&index=1&id=18a9013f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a9013f",
  null
  
)

export default component.exports